import React from 'react';
import { NoImage } from '@next-common/shared-svg';
import Box from '@mui/material/Box';
import { nonAvailableImg, noImg } from './Image.style';
export const Image = ({ imageUrl, noImgSettings, alt, styleCSS }) => {
    if (!imageUrl) {
        return (React.createElement(Box, { sx: noImg },
            React.createElement(NoImage, { width: noImgSettings.width, height: noImgSettings.height })));
    }
    return React.createElement(Box, { component: "img", sx: nonAvailableImg, alt: alt, style: styleCSS, src: imageUrl });
};
